/*
 * Returns frequency in format "6M" for us to be able to compare it to
 * products terms and find the one we need
 */

export const getCDFrequency = (cdTermDescription?: string): string => {
  if (!cdTermDescription) return ''
  const cdTerm = cdTermDescription.split('-')

  if (cdTerm.length === 2) {
    return `${
      Number(cdTerm[0]) *
      (cdTerm[1].toUpperCase() === 'Year'.toUpperCase() ? 12 : 1)
    }M`
  }

  if (cdTerm.length === 1) {
    return `${cdTerm[0]}M`
  }

  return ''
}
